module.exports = __webpack_public_path__ + "static/media/shop_20230808.fe613f6e.png";